import styled from '@emotion/styled';
import { Text, Link } from 'roo-ui/components';
import { themeGet } from 'styled-system';

export const MembershipTier = styled(Text)`
  font-size: ${themeGet('fontSizes.header.sm')};
  font-weight: ${themeGet('fontWeights.bold')};
`;

export const StyledText = styled(Text)`
  font-size: ${themeGet('fontSizes.header.sm')};
  font-weight: bold;
`;

export const JoinLink = styled(Link)`
  color: ${themeGet('colors.white')};
  &:hover {
    color: ${themeGet('colors.white')};
  }
`;

export const HoveredText = styled(Text)`
  &:hover {
    color: ${themeGet('colors.brand.primary')};
  }
`;
